// extracted by mini-css-extract-plugin
module.exports = {"paper":"HarmoniaPaper_paper__3zduJ","paperRounded":"HarmoniaPaper_paperRounded__2mr2q"};